import { FC } from "react";
import { CXWorkspaceSettingsLayout } from "../CXWorkspaceSettingsLayout";
import { CXWorkspaceNotificationsSettings } from "./components/CXWorkspaceNotificationsSettings";

export const CXWorkspaceNotificationsPage: FC = () => (
  <CXWorkspaceSettingsLayout>
    <CXWorkspaceNotificationsSettings />
  </CXWorkspaceSettingsLayout>
);
